module.exports = __webpack_public_path__ + "img/illu_02.9d61c300.svg";